import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Parallax } from 'react-scroll-parallax';
import { m } from 'framer-motion';
import { Keyboard } from 'swiper/modules';
import { SwiperSlide, Swiper } from 'swiper/react';
import Buttons from '../../../Litho/Components/Button/Buttons';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';

const swiperData = [
	{
		img: '/assets/img/services/road-freight.jpg',
		title: 'Truckload capacity',
		content: 'Secure capacity across major lanes for reliable schedules.',
	},
	{
		img: '/assets/img/services/road-freight-1.jpg',
		title: 'Consolidation efficiency',
		content: 'Save costs with optimized LTL networks and routing.',
	},
	{
		img: '/assets/img/services/road-freight-2.jpg',
		title: 'Dedicated fleets',
		content: 'Repeat routes with consistent drivers and equipment.',
	},
];

const ParallaxServices = () => {
	const swiperRef = React.useRef(null);
	return (
		<m.section
			id='services'
			className='relative py-[130px] lg:py-[90px] sm:py-[75px] xs:py-[50px]'
			{...fadeIn}
		>
			<Parallax
				className='lg-no-parallax bg-cover absolute -top-[50px] left-0 w-full h-[100vh]'
				translateY={[-50, 50]}
				style={{
					backgroundImage: `url(https://via.placeholder.com/1920x1100?text=Road+Network)`,
				}}
			></Parallax>
			<Container>
				<Row>
					<Col xl={7} lg={8} md={12} className='md:mb-[40px]'>
						<Row>
							<Col className='relative mb-12 lg:mb-[40px] sm:mb-[7.5rem] xs:mb-[4.5rem]'>
								<span className='font-serif mb-[20px] text-gradient bg-gradient-to-r from-[#bd3531] to-[#23262d] inline-block uppercase font-medium tracking-[1px]'>
									Our core capabilities
								</span>
								<h5 className='font-serif font-semibold text-darkgray'>
									End-to-end road freight solutions for your business.
								</h5>
								<p className='w-[80%] mb-[4.5rem] md:w-full'>
									We deliver dependable trucking services with proactive
									tracking and responsive operations teams to keep your cargo
									moving.
								</p>
								<div className='flex'>
									<div
										onClick={() => swiperRef.current.swiper.slidePrev()}
										className='btn-slider-next transition-default rounded-full flex justify-center items-center text-black bg-transparent border-[1px] border-mediumgray right-inherit left-[65px] h-[40px] w-[40px] cursor-pointer hover:shadow-[0_0_20px_rgba(0,0,0,0.15)] hover:border-white hover:bg-white'
									>
										<button className='text-xmd leading-none'>
											<i className='feather-arrow-left'></i>
										</button>
									</div>
									<div
										onClick={() => swiperRef.current.swiper.slideNext()}
										className='btn-slider-prev transition-default rounded-full flex justify-center items-center text-black right-inherit border-[1px] border-mediumgray h-[40px] w-[40px] ml-[10px] cursor-pointer hover:shadow-[0_0_20px_rgba(0,0,0,0.15)] hover:border-white hover:bg-white'
									>
										<button className='text-xmd leading-none'>
											<i className='feather-arrow-right'></i>
										</button>
									</div>
								</div>
							</Col>
							<Col>
								<Swiper
									ref={swiperRef}
									effect='slide'
									modules={[Keyboard]}
									keyboard={{ enabled: true, onlyInViewport: true }}
									slidesPerView={1}
									loop={true}
								>
									{swiperData.map((item, i) => (
										<SwiperSlide key={i}>
											<div className='border border-mediumgray rounded-[4px] overflow-hidden mr-[5px] xs:mr-0'>
												<Row className='g-0 row-cols-1 row-cols-sm-2'>
													<Col
														className='cover-background xs:h-[250px] z-10'
														style={{ backgroundImage: `url(${item.img})` }}
													></Col>
													<Col>
														<div className='p-16 lg:p-12'>
															<span className='font-serif text-darkgray font-medium inline-block mb-[15px] text-xmd'>
																{item.title}
															</span>
															<p className='mb-[25px]'>{item.content}</p>
															<Buttons
																href='/contact-us'
																className='btn-fill font-medium font-serif uppercase rounded md:mb-[15px]'
																themeColor='#232323'
																color='#fff'
																size='xs'
																title='get quote'
															/>
														</div>
													</Col>
												</Row>
											</div>
										</SwiperSlide>
									))}
								</Swiper>
							</Col>
						</Row>
					</Col>
					<Col lg={4} md={12} xl={{ offset: 1 }}>
						<div className='sticky top-0'>
							<div className='ourservice-list relative bg-gradient-to-bl from-[#bd3531] to-[#23262d] w-full overflow-hidden rounded-[4px] p-16 lg:p-12 md:p-16'>
								<i className='line-icon-Cursor-Click2 text-[11rem] leading-[11rem]  text-darkgray opacity-20 absolute -top-[20px] -left-[30px]'></i>
								<h6 className='font-serif font-medium text-white mb-[35px] sm:mb-[15px] relative z-[1]'>
									Custom trucking solutions
								</h6>
								<ul className='list-style-03 font-serif'>
									<li className='border-[#ffffff33] text-white !py-[10px] px-0 border-b mb-0'>
										FTL
									</li>
									<li className='border-[#ffffff33] text-white !py-[10px] px-0 border-b mb-0'>
										LTL
									</li>
									<li className='border-[#ffffff33] text-white !py-[10px] px-0 border-b mb-0'>
										Dedicated fleet
									</li>
									<li className='border-[#ffffff33] text-white !py-[10px] px-0 border-b mb-0'>
										Express delivery
									</li>
									<li className='border-[#ffffff33] text-white !py-[10px] px-0 border-b mb-0 pb-0'>
										Temperature control
									</li>
								</ul>
							</div>
						</div>
					</Col>
				</Row>
			</Container>
		</m.section>
	);
};

export default ParallaxServices;
